import React from "react";
import styled from "styled-components";
import DefaultRoutesSVG from "../../../../SMARTCITY/assets/svg/components/DefaultRoutesSVG";
import * as Icon from "../../../../TEMPLATE/components/Map/smartiscity/Icons";
import { AmeaCategorySingularName } from "../helpers";

const RightSidePanel = ({
  showRightSide,
  selectedItem,
  categoryId,
  selectedCategory,
}) => {
  const InfoSection = ({ title, content }) => (
    <InfoSectionContainer>
      <SectionTitle>{title}</SectionTitle>
      <SectionText>{content}</SectionText>
      <SectionDevider />
    </InfoSectionContainer>
  );

  const InfrastructurePoint = ({ step, index }) => (
    <div>
      <PointContainer>
        <MarkerContainer>
          <MarkerNumber $isTwoDigits={index > 8}>{index + 1}</MarkerNumber>
          <img src={Icon.baseMarker} alt="Marker" />
        </MarkerContainer>
        <PointInfo>
          <p>{`${AmeaCategorySingularName(step.category)} (${step.title})`}</p>
          <p>{step.subTitle}</p>
        </PointInfo>
      </PointContainer>
      <SectionDevider />
    </div>
  );

  const renderMeteoData = (items) => {
    return items?.map((item, index) => (
      <MeteoItem key={`right_side_panel_content_${index}`}>
        <MeteoIcon
          src={`https://alexandria.smartiscity.gr/gallery/vars/Big/${item.sensorvar_icon}`}
        />
        <MeteoInfo>
          <SectionTitle>{item.sensorvar_description}</SectionTitle>
          <SectionText>{item.date_insert}</SectionText>
        </MeteoInfo>
        <MeteoValue>{`${parseFloat(item.measurement).toFixed(2)} ${
          item.sensorvar_unit
        }`}</MeteoValue>
      </MeteoItem>
    ));
  };

  const renderParkingData = (item) => {
    return (
      <>
        <InfoBoxItem>
          <SectionTitle>Κατειλημμένη:</SectionTitle>
          <SectionText>{item.IsOccupied ? "Ναι" : "Όχι"}</SectionText>
        </InfoBoxItem>
        <InfoBoxItem>
          <SectionTitle>Κατειλημμένη από:</SectionTitle>
          <SectionText>{item.IsOccupied ? item.OccupiedFrom : "-"}</SectionText>
        </InfoBoxItem>
        <InfoBoxItem>
          <SectionTitle>Τύπος:</SectionTitle>
          <SectionText>{item.Type}</SectionText>
        </InfoBoxItem>
      </>
    );
  };

  const renderInfoBoxData = (item) => (
    <InfoBoxItem>
      <SectionTitle>{item[0]?.content}</SectionTitle>
      <SectionText>{item[0]?.value}</SectionText>
    </InfoBoxItem>
  );

  const renderCategoryIcon = () => {
    switch (categoryId) {
      case "122":
        return <DefaultRoutesSVG color="#fff" />;
      case "5":
        return <i className="im im-icon-Cloud-Sun" />;
      case "24":
        return <i className="im im-icon-Car-2" />;
      case "31":
        return <i className="im im-icon-Monitor-Vertical" />;
      default:
        return null;
    }
  };

  const renderTitle = () => {
    if (categoryId === "122") {
      return `${selectedCategory === "infra" ? "Υποδομή" : "Διαδρομή"} ${
        selectedItem?.title
      }`;
    }
    return categoryId === "24"
      ? `Θέση ${selectedItem?.LabelOnStreet}`
      : selectedItem?.mysensor_name;
  };

  const renderContent = () => {
    switch (categoryId) {
      case "5":
        return renderMeteoData(selectedItem?.details);
      case "24":
        return selectedItem && renderParkingData(selectedItem);
      case "31":
        return (
          selectedItem?.metrics && renderInfoBoxData(selectedItem?.metrics)
        );
      case "122":
        return selectedCategory === "infra"
          ? renderInfrastructureInfo()
          : renderRouteInfo();
      default:
        return null;
    }
  };

  const renderInfrastructureInfo = () => (
    <>
      <MainTitle>Πληροφορίες Υποδομής</MainTitle>
      <InfoSection
        title="Κατηγορία Υποδομής"
        content={selectedItem?.category}
      />
      <InfoSection title="Χρήση Υποδομής" content={selectedItem?.type} />
    </>
  );

  const renderRouteInfo = () => {
    if (selectedItem) {
      return (
        <>
          <MainTitle>Πληροφορίες Διαδρομής</MainTitle>
          <InfoSection
            title="Κατηγορία Διαδρομής"
            content={selectedItem?.category}
          />
          <InfoSection
            title="Σημείο έναρξης"
            content={selectedItem?.start?.address}
          />
          <InfoSection
            title="Σημείο προορισμού"
            content={selectedItem?.end?.address}
          />
          <InfoSection
            title="Αριθμός Σημείων"
            content={selectedItem?.infrastructures?.length}
          />
          <InfoSection
            title="Απόσταση Διαδρομής"
            content={`${selectedItem?.distance}m`}
          />
          <MainTitle>Σημεία Υποδομών</MainTitle>
          {selectedItem?.infrastructures?.map((step, index) => (
            <InfrastructurePoint key={index} step={step} index={index} />
          ))}
        </>
      );
    }
  };

  return (
    <RightSideContainer $top={showRightSide.get ? "70px" : "-84vh"}>
      {selectedItem && (
        <div style={{ width: "100%" }}>
          <Header>
            <CategoryIcon $large={categoryId === "5" || categoryId === "31"}>
              {renderCategoryIcon()}
            </CategoryIcon>
            <Title>{renderTitle()}</Title>
            <CloseIcon
              src={Icon.close}
              onClick={() => showRightSide.set(false)}
            />
          </Header>
          <HeaderDivider />
          <Content $isPadded={categoryId === "5"}>{renderContent()}</Content>
        </div>
      )}
    </RightSideContainer>
  );
};

// import React from "react";
// import styled from "styled-components";
// import DefaultRoutesSVG from "../../../../SMARTCITY/assets/svg/components/DefaultRoutesSVG";

// import * as Icon from "../../../../TEMPLATE/components/Map/smartiscity/Icons";
// import { AmeaCategorySingularName } from "../helpers";

// function RightSidePanel({
//   showRightSide,
//   selectedItem,
//   categoryId,
//   selectedCategory,
// }) {
//   const renderMeteoData = (items) => {
//     return items?.map((item, index) => {
//       return (
//         <div
//           key={`right_side_panel_content_${index}`}
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             alignItems: "center",
//             // gap: "2px",
//           }}
//         >
//           <img
//             style={{ width: "40px" }}
//             src={`https://alexandria.smartiscity.gr/gallery/vars/Big/${item.sensorvar_icon}`}
//           />
//           <div>
//             <SectionTItle>{item.sensorvar_description}</SectionTItle>
//             <SectionText style={{ fontSize: "12px", paddingBlock: "0" }}>
//               {item.date_insert}
//             </SectionText>
//           </div>
//           <p
//             style={{
//               marginLeft: "auto",
//               color: "#fff",
//               width: "70px",
//               textAlign: "right",
//             }}
//           >{`${parseInt(item.measurement).toFixed(2)} ${
//             item.sensorvar_unit
//           }`}</p>
//         </div>
//       );
//     });
//   };

//   const renderInfoBoxData = (item) => {
//     return (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "center",
//           // gap: "2px",
//         }}
//       >
//         <SectionTItle>{item[0]?.content}</SectionTItle>
//         <SectionText style={{ fontSize: "12px", paddingBlock: "0" }}>
//           {item[0]?.value}
//         </SectionText>
//       </div>
//     );
//   };

//   return (
//     <RightSideContainer $top={showRightSide.get ? "70px" : "-84vh"}>
//       {selectedItem && (
//         <div
//           style={{
//             width: "100%",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               gap: "37px",
//               justifyContent: "space-between",
//               alignItems: "center",
//               paddingBlock: "20px 6px",
//               paddingInline: "20px",
//             }}
//           >
//             <div
//               style={{
//                 width:
//                   categoryId === "5" || categoryId === "31" ? "80px" : "50px",
//                 height: "50px",
//                 backgroundColor: "#27AAE1",
//                 borderRadius: "12px",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               {categoryId === "122" && <DefaultRoutesSVG color="#fff" />}
//               {categoryId === "5" && (
//                 <i
//                   className="im im-icon-Cloud-Sun"
//                   style={{ color: "#fff", fontSize: "24px", fontWeight: "600" }}
//                 ></i>
//               )}
//               {categoryId === "31" && (
//                 <i
//                   className="im im-icon-Monitor-Vertical"
//                   style={{ color: "#fff", fontSize: "24px", fontWeight: "600" }}
//                 ></i>
//               )}
//             </div>
//             {categoryId === "5" ||
//               (categoryId === "31" && (
//                 <p
//                   style={{
//                     color: "#fff",
//                     fontWeight: "500",
//                     fontSize: "20px",
//                     lineHeight: "25px",
//                     textAlign: "center",
//                   }}
//                 >
//                   {selectedItem.mysensor_name}
//                 </p>
//               ))}
//             {categoryId === "122" && (
//               <p
//                 style={{
//                   color: "#fff",
//                   fontWeight: "500",
//                   fontSize: "20px",
//                   lineHeight: "25px",
//                 }}
//               >
//                 {selectedCategory === "infra" ? "Υποδομή" : "Διαδρομή"}
//                 {selectedItem?.title}
//               </p>
//             )}
//             <img
//               onClick={() => showRightSide.set(false)}
//               style={{ cursor: "pointer" }}
//               src={Icon.close}
//             />
//           </div>
//           <HeaderDivider />
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//               padding: categoryId === "5" ? "22px" : "unset",
//             }}
//           >
//             {categoryId === "5" && renderMeteoData(selectedItem?.details)}
//             {categoryId === "31" && renderInfoBoxData(selectedItem?.metrics)}
//           </div>
//           {categoryId === "122" && selectedCategory === "infra" && (
//             <>
//               <MainTitle>Πληροφορίες Υποδομής</MainTitle>
//               <SectionTItle>Κατηγορία Υποδομής</SectionTItle>
//               <SectionText>{selectedItem?.category}</SectionText>
//               <SectionDevider />
//               <SectionTItle>Χρήση Υποδομής</SectionTItle>
//               <SectionText>{selectedItem?.type}</SectionText>
//               <SectionDevider />
//             </>
//           )}
//           {categoryId === "122" && selectedCategory === "routes" && (
//             <>
//               <MainTitle>Πληροφορίες Διαδρομής</MainTitle>
//               <SectionTItle>Κατηγορία Διαδρομής</SectionTItle>
//               <SectionText>{selectedItem?.category}</SectionText>
//               <SectionDevider />
//               <SectionTItle>Σημείο έναρξης</SectionTItle>
//               <SectionText>{selectedItem?.start.address}</SectionText>
//               <SectionDevider />
//               <SectionTItle>Σημείο προορισμού</SectionTItle>
//               <SectionText>{selectedItem?.end.address}</SectionText>
//               <SectionDevider />
//               <SectionTItle>Αριθμός Σημείων</SectionTItle>
//               <SectionText>{selectedItem?.infrastructures.length}</SectionText>
//               <SectionDevider />
//               <SectionTItle>Απόσταση Διαδρομής</SectionTItle>
//               <SectionText>{selectedItem?.distance}m</SectionText>
//               <SectionDevider />
//               <MainTitle>Σημεία Υποδομών</MainTitle>
//               {selectedItem?.infrastructures.map((step, index) => {
//                 return (
//                   <div>
//                     <div
//                       style={{
//                         paddingInline: "20px",
//                         height: "fit-content",
//                         display: "flex",
//                         flexDirection: "row",
//                         alignItems: "flex-start",
//                         gap: "20px",
//                         position: "relative",
//                         paddingBlock: "4px",
//                       }}
//                     >
//                       <div style={{ position: "relative" }}>
//                         <p
//                           style={{
//                             fontSize: "20px",
//                             color: "white",
//                             position: "absolute",
//                             top: "6px",
//                             left: index > 8 ? "30% " : "40%",
//                             marginBottom: "4px",
//                           }}
//                         >
//                           {index + 1}
//                         </p>
//                         <img src={Icon.baseMarker} />
//                       </div>
//                       <div style={{ color: "white", paddingTop: "10px" }}>
//                         <p>{`${AmeaCategorySingularName(step.category)}  (${
//                           step.title
//                         })`}</p>
//                         <p>{step.subTitle}</p>
//                       </div>
//                     </div>
//                     <SectionDevider />
//                   </div>
//                 );
//               })}
//             </>
//           )}
//         </div>
//       )}
//     </RightSideContainer>
//   );
// }

// export default RightSidePanel;

export default RightSidePanel;

const RightSideContainer = styled.div`
  width: 380px;
  height: calc(100vh - 70px - 30px);
  position: absolute;
  top: ${(props) => props.$top};
  right: 0;
  background-color: #686868;
  transition: all 1.4s ease;
  overflow-x: hidden;
  overflow-y: scroll;
  overflow-y: scroll;
  z-index: 2;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */
`;

const HeaderDivider = styled.hr`
  width: 90%;
  border-bottom: 2px solid;
  border-image-source: linear-gradient(
    to left,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 35%,
    rgba(255, 255, 255, 0.8) 65%,
    rgba(255, 255, 255, 0) 100%
  );
  border-image-slice: 1;
`;

const SectionDevider = styled.hr`
  width: 90%;
  border-bottom: 1px solid #ffffff04;
  border-left: none;
  border-right: none;
  margin-block: 10px;
`;

const MainTitle = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-block: 20px;
`;

const InfoSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SectionTitle = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter: 0.5%;
  color: #fff;
  padding-inline: 20px;
`;

const SectionText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  letter: 0.5%;
  padding: 0 20px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 37px;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 6px;
`;

const CategoryIcon = styled.div`
  width: ${(props) => (props.$large ? "80px" : "50px")};
  height: 50px;
  background-color: #27aae1;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
  }
`;

const Title = styled.p`
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
`;

const CloseIcon = styled.img`
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: ${(props) => (props.$isPadded ? "22px" : "unset")};
`;

const MeteoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const MeteoIcon = styled.img`
  width: 40px;
`;

const MeteoInfo = styled.div``;

const MeteoValue = styled.p`
  margin-left: auto;
  color: #fff;
  width: 70px;
  text-align: right;
`;

const InfoBoxItem = styled.div`
  width: 100%;
  // background-color: red;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const PointContainer = styled.div`
  padding: 4px 20px;
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  position: relative;
`;

const MarkerContainer = styled.div`
  position: relative;
`;

const MarkerNumber = styled.p`
  font-size: 20px;
  color: white;
  position: absolute;
  top: 6px;
  left: ${(props) => (props.$isTwoDigits ? "30%" : "40%")};
  margin-bottom: 4px;
`;

const PointInfo = styled.div`
  color: white;
  padding-top: 10px;
`;
